import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@justgiving/react-tracking';
import styles from './SocialButtonsList.scss';
import { useShareUrls } from '../../hooks';
import { captureException } from '@sentry/browser';

export type FacebookShareProps = {
  buttonText?: string;
  showPrefix?: boolean;
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

const FacebookShare: FunctionComponent<FacebookShareProps> = ({
  buttonText,
  trackingData,
  className,
  showPrefix,
  onClick = () => {},
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const shareUrls = useShareUrls();

  if (!shareUrls) {
    return null;
  }

  const facebookText = () => {
    const prefix = showPrefix && (
      <>
        <span className={styles.facebookButtonText}>
          {t('common.shareOn', 'Share on ')}
        </span>
        Facebook
      </>
    );

    return prefix || 'Facebook';
  };

  const handleClick = () => {
    FB.ui(
      {
        method: 'share',
        href: shareUrls.facebook.url,
      },
      response => {
        if (response && (response.error_message || response.error_code)) {
          captureException({
            facebookErrorCode: response.error_code,
            facebookErrorMessage: response.error_message,
          });
        }
      },
    );
    onClick();
  };

  return (
    <Button
      className={`jg-btn jg-btn--facebook ${styles.button} ${className || ''}`}
      onClick={handleClick}
      type="button"
      trackingData={{
        action_name: 'click',
        subtype: 'share',
        event: 'click',
        event_value: 'facebook',
        ...trackingData,
      }}
    >
      {buttonText || facebookText()}
    </Button>
  );
};

export default FacebookShare;
